<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          Activity Log
          <a
            class="btn btn-default"
            @click="refresh"
          >
            <i
              class="fas fa-sync-alt"
              aria-hidden="true"
            />
          </a>
        </h1>
      </div>
    </section>
    <section class="search">
      <div class="ns-container">
        <div class="row admin-list">
          <TableServer :options="options" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    TableServer: () => import('@/components/_vue/TableServer'),
  },

  data() {
    return {
      options: {
        // 'buttons' : 'admin-actions',
        url: '/api/admin/activity-log',
        name: 'members',
        columns: ['actions', 'id', 'log_name', 'description', 'subject_id', 'subject_type', 'causer_id', 'causer_type', 'properties', 'createdAt', 'updatedAt'],
        tableOptions: {
          perPage: 100,
          sortable: ['id', 'log_name', 'description', 'subject_id', 'subject_type', 'causer_id', 'causer_type', 'properties', 'createdAt', 'updatedAt'],
          orderBy: {
            column: 'createdAt',
            ascending: false,
          },
          filterable: ['log_name', 'description', 'subject_id', 'causer_id'],
        },
      },
    };
  },

  methods: {
    refresh() {
      Bus.$emit('refresh');
    },
  },
};
</script>
